<template>
    <div>
        <div v-if="options_loaded && passed_filter" class="designeroption" :data-designer-component-id="component_id">
            <h3>{{ title }}</h3>
            <div class="stylesoption">
                <table>
                    <tbody>
                    <tr>
                        <td width="25%">&nbsp;</td>
                        <td width="25%">Left</td>
                        <td width="25%">Top</td>
                        <td width="25%">Right</td>
                    </tr>
                    <tr v-for="(option, index) in filtered_option_list" :key="index">
                        <td>{{ option.label }}</td>
                        <td>
                        <span>
                            <select class="form-control addons" v-model="target.left[option.value]" :disabled="isColumnDisabled('left', option.value)">
                                <option v-for="i in addon_limit" :value="i-1">{{ i-1 }}</option>
                            </select>
                        </span>
                        </td>
                        <td>
                        <span>
                            <select class="form-control addons" v-model="target.top[option.value]" :disabled="isColumnDisabled('top', option.value)">
                                <option v-for="i in addon_limit" :value="i-1">{{ i-1 }}</option>
                            </select>
                        </span>
                        </td>
                        <td>
                        <span>
                            <select class="form-control addons" v-model="target.right[option.value]" :disabled="isColumnDisabled('right', option.value)">
                                <option v-for="i in addon_limit" :value="i-1">{{ i-1 }}</option>
                            </select>
                        </span>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <div class="p-3" v-if="extra_text != ''">
                    {{ extra_text }}
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    import Question from "../mixin/Question.vue";

    export default {
        mixins: [
            Question
        ],
        props: {
            title: {
                default(){
                    return 'Select Any Necessary Add Ons';
                }
            },
            component_id: {
                default(){
                    return 'addons';
                }
            },
            frameProfile: {
                required: true
            },
            frameCombination: {
                default(){
                    return '';
                }
            },
            extra_text: {
                default(){
                    return '';
                }
            },
            addon_limit: {
                default() {
                    return 2;
                }
            },
        },
        mounted(){
            for (var propertyName in this.localTarget) {
                if (Array.isArray(this.localTarget[propertyName])){
                    this.localTarget[propertyName] = {};
                }
            }
        },
        computed: {
            filtered_option_list(){
                if (Array.isArray(this.option_list)) {
                    return this.option_list.filter((key) => {
                        return key.value !== null;
                    });
                } else {
                    return [];
                }
            },
            passed_filter(){
                return this.variable_ready(this.frameProfile);
            },
            url(){
                return '/api/options/' + this.fabricator + '/technical-addon?profile=' + this.frameProfile + '&frame_combination=' + this.frameCombination;
            },
            cache_key(){
                return '_' + this.frameProfile + '_' + this.frameCombination;
            },
            selectedLeft() {
                return Object.keys(this.localTarget.left).find(
                    (key) => this.localTarget.left[key] > 0
                );
            },
            selectedTop() {
                return Object.keys(this.localTarget.top).find(
                    (key) => this.localTarget.top[key] > 0
                );
            },
            selectedRight() {
                return Object.keys(this.localTarget.right).find(
                    (key) => this.localTarget.right[key] > 0
                );
            },
        },
        methods: {
            select_first(){
                // Comment because Mike
            },
            isColumnDisabled(columnType, currentRowKey) {
                let selectedRow = null;

                if (columnType === 'left') {
                    selectedRow = this.selectedLeft;
                } else if (columnType === 'top') {
                    selectedRow = this.selectedTop;
                } else if (columnType === 'right') {
                    selectedRow = this.selectedRight;
                }

                if (!selectedRow) {
                    return false;
                }

                if (
                    (columnType === 'left' && this.localTarget.left[currentRowKey] > 0) ||
                    (columnType === 'top' && this.localTarget.top[currentRowKey] > 0) ||
                    (columnType === 'right' && this.localTarget.right[currentRowKey] > 0)
                ) {
                    return false;
                }

                return true;
            },
        },
        watch: {
            'frameProfile': function (val, oldVal) {
                this.update_options();
            },
            'frameCombination': function (val, oldVal) {
                this.update_options();
            },
            'filtered_option_list': function (new_val) {
                if (new_val.length > 0){

                    let options_to_check = [
                        this.localTarget.left,
                        this.localTarget.right,
                        this.localTarget.top,
                    ];

                    options_to_check.forEach((val) => {
                        for (var propertyName in val) {
                            if (new_val.find((el) => {
                                    return parseInt(el.value) === parseInt(propertyName);
                                }) === undefined) {
                                delete val[propertyName];
                            }
                        }
                    });
                }
            }
        }
    }
</script>
